// extracted by mini-css-extract-plugin
module.exports = {"blogReviewer":"az_nr","reviewerText":"az_or","withVerticalPadding":"az_pr","withDate":"az_qr"};